export default __webpack_public_path__ + "static/media/point.fc19961c.png";